import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';

import styles from './Badge.module.scss';

type BadgeProps = {
  className?: string;
};

export const Badge = observer<PropsWithChildren & BadgeProps>(
  ({ children, className }) => (
    <div className={clsx(styles.badge, className)}>{children}</div>
  ),
);
